export const global = {
  skipToContent: 'Springe zum Inhalt',
  startProjectNow: 'Jetzt Projekt starten',
  startNow: 'Jetzt loslegen',
  bath: 'Bad',
  floorer: 'Bodenleger',
  windowsAndDoors: 'Fenster & Türen',
  windowsAndDoorsSlug: 'fenster-und-tueren',
  heating: 'Heizung',
  kitchen: 'Küche',
  kitchenSlug: 'kuechen',
  solarPlants: 'Solaranlagen',
  inputRequiredError: 'Bitte füllen sie dieses Feld aus',
  overLimit: 'Ihr Text überschreitet das vorgegebene Limit.',
  railing: 'Geländer',
  railingSlug: 'metallbau-gelaender',
  painterAndPlasterer: 'Maler & Gipser',
  painterAndPlastererSlug: 'maler',
  paver: 'Plattenleger',
  carpenter: 'Schreiner',
  stair: 'Treppe',
  stairSlug: 'metallbau-treppe',
  interiorConstruction: 'Innenausbau',
  paintingAndPlasterer: 'Maler & Gipser',
  cladding: 'Gebäudehülle',
  architectAndConstructionManager: 'Architekt & Bauleiter',
  architectAndConstructionManagerSlug: 'architekt-bauleitung',
  balcony: 'Balkon',
  balconySlug: 'metallbau-balkon',
  carport: 'Carport',
  roofer: 'Dachdecker',
  garageAndGates: 'Garagen & Tore',
  garage: 'Garage',
  isolationAndFacade: 'Isolation & Fassade',
  isolationAndFacadeSlug: 'isolation-fassade',
  awnings: 'Markisen',
  awningsSlug: 'markisen-sonnenstoren',
  rollerBlinds: 'Storen',
  rollerBlindsSlug: 'storen-rolladen',
  roofingAndPergola: 'Überdachung & Pergola',
  roofingAndPergolaSlug: 'metallbau-ueberdachung-pergola',
  wintergarden: 'Wintergarten',
  chippie: 'Zimmermann',
  housingTechnology: 'Haustechnik',
  alarmSystem: 'Alarmanlage',
  alarmSystemSlug: 'alarmanlagen',
  electrician: 'Elektriker',
  airConditioning: 'Klima',
  waterConditioning: 'Wasseraufbereitung',
  waterConditioningSplitted: 'Wasser-<br />aufbereitung',
  others: 'Sonstiges',
  gardener: 'Gärtner',
  gardenerSlug: 'gaertner',
  broker: 'Makler',
  metalConstruction: 'Metallbau',
  assembling: 'Montage',
  whirlpool: 'Whirlpool',
  fencesAndPrivacyShields: 'Zaun & Sichtschutz',
  fencesSlug: 'zaun-und-sichtschutz',
  formFieldCompany: 'Firma',
  formFieldWebsite: 'Webseite',
  formFieldEmail: 'Email',
  formFieldSalutation: 'Anrede',
  formFieldOptionMan: 'Herr',
  formFieldOptionWoman: 'Frau',
  formFieldFirstName: 'Vorname',
  formFieldLastName: 'Nachname',
  formFieldPhone: 'Mobil/Telefon',
  formFieldLandline: 'Telefon',
  formFieldCellPhone: 'Mobile',
  formFieldAddress: 'Strasse / Nr.',
  formFieldZip: 'PLZ',
  formFieldCity: 'Ort',
  formFieldComment: 'Kommentar',
  formButtonReturn: 'Zurück',
  formButtonContinue: 'Weiter',
  saveUpTo30Percent: 'Bis zu 30% sparen',
  swissCompanies: 'Schweizer Fachbetriebe',
  germanCompanies: 'Deutsche Fachbetriebe',
  freeEfficientNonCommittal: 'Kostenlos, effizient &<br /> unverbindlich',
  minute: 'Minute',
  minutes: 'Minuten',
  fillOutAllFields: 'Bitte füllen sie alle Pflichtfelder aus.',
  landscaper: 'Landschaftsarchitekt',
  mason: 'Maurer',
  multipleChoice: '(Mehrfachauswahl möglich)',
  chargingColumn: 'Ladestation',
  login: 'Login',
  register: 'Registrieren',
  logout: 'Abmelden',
  email: 'E-Mail',
  password: 'Passwort',
  firstName: 'Vorname',
  lastName: 'Nachname',
  projects: 'Renovationen',
  window: 'Fenster',
  solar: 'Solaranlagen',
  fence: 'Zaun & Sichtschutz',
  metalconstruction: 'Metallbau',
  rollerblinds: 'Storen',
  painter: 'Maler',
  isolation: 'Isolation & Fassade',
  waterconditioning: 'Wasseraufbereitung',
  airconditioning: 'Klima',
  stairs: 'Treppe',
  pergola: 'Pergola​',
  architect: 'Architekt & Bauleiter',
  chargingcolumn: 'Ladestation',
  custom: 'Benutzerdefiniert',
  status: 'Status',
  creationDate: 'Erstellungsdatum',
  date: 'Datum',
  important: 'Wichtig',
  sortBy: 'Sortieren nach',
  notifications: 'Benachrichtigungen',
  quote: 'Offerte',
  quotes: 'Offerten',
  toDo: 'To-do',
  toDos: 'To-dos',
  documentation: 'Dokumentation',
  lastChange: 'Letzte Aktualisierung',
  companyName: 'Firmenname',
  price: 'Preis',
  cancel: 'Abbrechen',
  phone: 'Telefon',
  note: 'Notiz',
  notes: 'Notizen',
  files: 'Dateien',
  roof: 'Dach',
  heatdistribution: 'Wärmerverteilung',
  frontage: 'Fassade',
  floor: 'Boden',
  structuralwork: 'Rohbau',
  immediately: 'Sofort',
  year: 'Jahr',
  years: 'Jahre',
  waterpipe: 'Wasserleitungen',
  shutters: 'Läden / Sonnenschutz',
  propertyborder: 'Grundstücksbegrenzung',
  return: 'Zurück',
  continue: 'Weiter',
  create: 'Erstellen',
  constructionYear: 'Baujahr',
  createRealEstate: 'Immobilie erstellen',
  teleHeating: 'Fernwärme',
  toDoOverview: 'To-do Übersicht',
  add: 'Hinzufügen',
  counselor: 'Ratgeber',
  comingSoon: 'Diese Funktion wird Ihnen Bald zur verfügung stehen.',
  realEstateOverview: 'Immobilienübersicht',
  emailDisabled: 'Ihre E-Mailadresse können Sie später in Ihrem Profil ändern.',
  alarmsystem: 'Alarmanlage',
  yes: 'Ja',
  no: 'Nein',
  appointmentOverview: 'Termin Übersicht',
  appointments: 'Termine',
  documents: 'Dokumente',
  documentsOverview: 'Meine Unterlagen',
  quality: 'Qualität',
  rapidity: 'Schnelligkeit',
  reliability: 'Zuverlässigkeit',
  invoiceOverview: 'Meine Rechnungen',
  faq: 'FAQs',
  skip: 'Überspringen',
  next: 'Weiter',
  gotIt: 'Verstanden',
  onboarding: 'onboarding',
}
